import { useContext, useEffect, useState } from "react";
import AppTable from "../../components/shared-components/table/AppTable";
import { AddTicketsInput } from "./AddTickets";
import { useLazyQuery } from "@apollo/client";
import { GET_EVENTS_BY_HOME_AND_AWAY_TEAM_ID, GET_EVENTS_BY_HOME_TEAM_ID, GET_EVENTS_BY_OTHER_LEAGUES } from "./api/addTicketsQuery";
import { Button, CircularProgress } from "@mui/material";
import addTicketStyles from "./AddTickets.module.css";
import styles from "../Settings/AppVersion.module.css";
import ToasterWithMessage from "../../components/shared-components/toaster";
import stylesUser from "../Users/Users.module.css";
import { globalContext } from "../../Provider/AppProvider";

const PickEvents = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    isFrom,
    page,
    search,
    setResetEvent,
    resetEvent
}: AddTicketsInput) => {
    const [events, setEvents] = useState<any>([]);
    const [selected, setSelected] = useState<number[]>([]);
    const [selectedEvents, setSelectedEvents] = useState<string[]>([]);
    const [checking, setChecking] = useState<boolean>(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [columnTypes, setColumnTypes] = useState('e_date');
    const [sortType, setSortType] = useState('asc');
    const { error } = ToasterWithMessage();
    const { globalState, handleGlobalState } = useContext<any>(globalContext);

    const activeFilter = (isFrom === 'eventsUpdate' || isFrom === 'eventsOtherLeagues') ? [true, false] : [true];

    const [getEventsForBulkList, { loading: bulkListLoading }] = useLazyQuery(GET_EVENTS_BY_HOME_TEAM_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(data);
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const [getEventsForSingleList, { loading: singleListLoading }] = useLazyQuery(GET_EVENTS_BY_HOME_AND_AWAY_TEAM_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(data);
            if (globalState.eventUpdate.updateEvent) {
                const tempState = { ...globalState };
                tempState.eventUpdate.updateEvent = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const [getEventsForOtherLeagues, { loading: otherListLoading }] = useLazyQuery(GET_EVENTS_BY_OTHER_LEAGUES, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(data);
            if (globalState.eventUpdate.updateEvent) {
                const tempState = { ...globalState };
                tempState.eventUpdate.updateEvent = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSelected([]);
        setCurrentPage(1);
    }

    const handlePageChange = (_event: any, newPage: number) => {
        setCurrentPage(newPage);
    }

    useEffect(() => {
        if (ticketDetails?.isBulkList) {
             if (ticketDetails?.leagueType?.toLowerCase() === "sports") {
            getEventsForBulkList({
                variables: {
                    homeTeamId: ticketDetails?.homeTeamId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    activeFilter: [true],
                }
            })}
            else{
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId || !eventName) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter: [true],
                    }
                })
            }
        } else {
            if (ticketDetails?.leagueType?.toLowerCase() === "sports") {
                getEventsForSingleList({
                    variables: {
                        homeTeamId: ticketDetails?.homeTeamId,
                        awayTeamId: ticketDetails?.awayTeamId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter: [true],
                    }
                })
            } else {
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId || !eventName) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter: [true],
                    }
                })
            }
        }
    }, [])

    useEffect(() => {
        if (!isFrom) return
        if (!['eventsUpdate', 'eventsOtherLeagues'].includes(isFrom)) return
        const { leagueId, eventName, leagueType } = ticketDetails || {}
        if (!leagueType) return
        if (page !== 1) return
        if (leagueType.toLowerCase() === "sports") {
            if (ticketDetails?.awayTeamId) {
                getEventsForSingleList({
                    variables: {
                        homeTeamId: ticketDetails?.homeTeamId,
                        awayTeamId: ticketDetails?.awayTeamId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter,
                    }
                })
            } else if (ticketDetails?.homeTeamId) {
                getEventsForBulkList({
                    variables: {
                        homeTeamId: ticketDetails?.homeTeamId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter,
                    }
                })
            }
        } else {
            const { leagueId, eventName } = ticketDetails || {}
            if (!leagueId || !eventName) return
            getEventsForOtherLeagues({
                variables: {
                    eventName: `%${eventName}%`,
                    leagueId: leagueId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    activeFilter,
                }
            })
        }
    }, [page, search]);

    useEffect(() => {
        if (resetEvent) {
            setEvents([])
            setResetEvent && setResetEvent(false)
        }
    }, [resetEvent])

    useEffect(() => {
        if (globalState.eventUpdate.updateEvent) {
            const { leagueId, eventName, leagueType } = ticketDetails || {}
            if (!leagueType) return
            if (page !== 1) return
            if (leagueType.toLowerCase() === "sports") {
                if (ticketDetails?.awayTeamId) {
                    getEventsForSingleList({
                        variables: {
                            homeTeamId: ticketDetails?.homeTeamId,
                            awayTeamId: ticketDetails?.awayTeamId,
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage,
                            orderBy: { [columnTypes]: sortType },
                            activeFilter,
                        }
                    })
                } else if (ticketDetails?.homeTeamId) {
                    getEventsForBulkList({
                        variables: {
                            homeTeamId: ticketDetails?.homeTeamId,
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage,
                            orderBy: { [columnTypes]: sortType },
                            activeFilter,
                        }
                    })
                }
            } else {
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId || !eventName) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                        activeFilter,
                    }
                })
            }
        }

    }, [globalState.eventUpdate.updateEvent]);

    useEffect(() => {

        const { leagueId, eventName, leagueType } = ticketDetails || {}

        if (!leagueType) return

        const useHomeTeamOnly = ticketDetails?.isBulkList || (isFrom === 'eventsUpdate' && !ticketDetails?.awayTeamId);

        if (useHomeTeamOnly && leagueType.toLowerCase() === "sports" && ticketDetails?.homeTeamId) {
            getEventsForBulkList({
            variables: {
                homeTeamId: ticketDetails?.homeTeamId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
                activeFilter,
            }
            })
        }

        else if (leagueType.toLowerCase() === "sports" && ticketDetails?.homeTeamId && ticketDetails?.awayTeamId) {
            getEventsForSingleList({
            variables: {
                homeTeamId: ticketDetails?.homeTeamId,
                awayTeamId: ticketDetails?.awayTeamId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
                activeFilter,
            }
            })
        }

        else {
            if (!leagueId || !eventName) return

            getEventsForOtherLeagues({
            variables: {
                eventName: `%${eventName}%`,
                leagueId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
                activeFilter,
            }
            })
        }

    }, [currentPage, rowsPerPage, sortType, columnTypes, ticketDetails, isFrom]);


    const GenerateEventsHeadCells = () => {
        const id = ["e_name", "e_date", "e_address", "e_date", 'action', 'action']
        const labels = ["Events", "Date", "Venue", "Venue Time", "Period Left", 'Action']
        const headCells = id.map((id, index) => ({
            id,
            label: labels[index],
        }));
        return headCells;
    }

    const handleEventNext = () => {
        if (selectedEvents?.length) {
            setTicketDetails({
                ...ticketDetails,
                eventId: selectedEvents
            });
            setPage(3);
        } else {
            error('Please select any one of the events')
        }

    }

    return (
        <>
            {
                (bulkListLoading || singleListLoading || otherListLoading) ? <div className={stylesUser.TableCircularProgress}>
                    <CircularProgress color="primary" size={35} />
                </div> :
                    <div style={{ width: '100%' }}>
                        <AppTable
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handlePageChange={handlePageChange}
                            setColumnTypes={setColumnTypes}
                            sortType={sortType}
                            setSortType={setSortType}
                            setSelected={setSelected}
                            setChecking={setChecking}
                            checking={checking}
                            selected={selected}
                            rowsPerPage={rowsPerPage}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            list={events}
                            tableTitle={ticketDetails?.isBulkList ? "pickEventsBulkList" : "pickEvents"}
                            generateHeadCells={GenerateEventsHeadCells}
                            selectedEvents={selectedEvents}
                            setSelectedEvents={setSelectedEvents}
                            tablePurpose={isFrom}
                        // handleDropdownChange={handleDropdownChange}
                        // selectedValues={selectedValues}
                        // setSelectedValues={setSelectedValues}
                        />
                        {
                            isFrom === "addTickets" && (events?.events?.length !== 0) && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <div className={addTicketStyles.eventBtnStyle}>
                                    <Button
                                        classes={{
                                            root: styles.separateStyleReferral
                                        }}
                                        disableRipple
                                        fullWidth
                                        type="button"
                                        onClick={handleEventNext}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
            }

        </>
    )
}

export default PickEvents;
